// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Medal24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Medal24Circle: FC<Medal24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0Zm0 6c-2.094 0-3.867.738-5.32 2.214C9.227 9.69 8.5 11.492 8.5 13.619c0 .968.164 1.881.492 2.738.328.857.79 1.619 1.383 2.286V26L16 24.096 21.625 26v-7.357a7.362 7.362 0 0 0 1.383-2.286c.328-.857.492-1.77.492-2.738 0-2.127-.727-3.929-2.18-5.405C19.867 6.738 18.094 6 16 6Zm3.75 17.167L16 22.19l-3.75.977v-2.953a7.84 7.84 0 0 0 1.77.75 7.112 7.112 0 0 0 1.98.274c.688 0 1.348-.092 1.98-.274a7.84 7.84 0 0 0 1.77-.75v2.953ZM16 7.904c1.563 0 2.89.556 3.984 1.667 1.094 1.111 1.641 2.46 1.641 4.048 0 1.587-.547 2.937-1.64 4.048-1.094 1.111-2.423 1.666-3.985 1.666-1.562 0-2.89-.555-3.984-1.666-1.094-1.111-1.641-2.46-1.641-4.048 0-1.587.547-2.937 1.64-4.048C13.11 8.461 14.438 7.904 16 7.904Zm0 2.858c-.781 0-1.445.278-1.992.834-.547.555-.82 1.23-.82 2.023 0 .794.273 1.468.82 2.024a2.692 2.692 0 0 0 1.992.834c.781 0 1.445-.279 1.992-.834.547-.556.82-1.23.82-2.024 0-.793-.273-1.468-.82-2.023A2.692 2.692 0 0 0 16 10.762Z" />
        </svg>
    );
};

export default Medal24Circle;
